import React, { CSSProperties, FC, SVGProps } from 'react';
import classNames from 'classnames';

interface JabraIconProps extends React.HTMLAttributes<HTMLDivElement> {
  Icon?: FC<SVGProps<SVGElement>>;
  iconStyle?: CSSProperties;
  viewBox?: string;
  label?: string;
}

export const JabraIcon: FC<JabraIconProps> = ({
  Icon,
  iconStyle,
  className,
  viewBox = '0 0 24 25',
  label,
  ...rest
}) => {
  if (!Icon) {
    console.error('Icon was not provided');
  }
  return Icon ? (
    <div
      className={classNames(className, 'jabra-icon', {
        'h-6': !/size-|h-/.test(className || ''),
        'w-6': !/size-|w-/.test(className || ''),
      })}
      {...rest}
    >
      <Icon
        role="img"
        style={iconStyle}
        viewBox={viewBox}
        preserveAspectRatio="xMidYMid meet"
        className="h-full w-full"
        {...(label ? { 'aria-label': label } : { 'aria-hidden': true })}
      />
    </div>
  ) : null;
};
